@if (state$ | async; as state) {
  @if (composerOpen()) {
    <div class="bom-note-composer">
      <textarea #composer class="bom-note-composer-input" rows="3" placeholder="Nowa notatka..."
        [disabled]="state.saving"
        (keydown.escape)="closeComposer()"></textarea>
      <button class="btn" [disabled]="state.saving" (click)="onSaveClick(composer.value)">Zapisz</button>
    </div>
  }

  @if (state.saveError) {
    <div class="bom-notes-save-error">{{ state.saveError }}</div>
  }

  @if (state.loading) {
    <!-- two notes' shadows: a header line and a body line each (0127) -->
    <div class="bom-note">
      <div class="bom-note-header"><span class="shadow shadow-short"></span></div>
      <span class="shadow shadow-long"></span>
    </div>
    <div class="bom-note">
      <div class="bom-note-header"><span class="shadow shadow-short"></span></div>
      <span class="shadow shadow-long"></span>
    </div>
  } @else {
    @for (note of state.notes ?? []; track note.id) {
      <div class="bom-note">
        <div class="bom-note-header">
          <div class="bom-note-header-name">{{ note.userName }}</div>
          <div class="font-monospace">{{ note.createdAt | date:'HH:mm dd.MM.yyyy' }}</div>
        </div>
        <div class="bom-note-body">{{ note.content }}</div>
      </div>
    } @empty {
      <div class="bom-notes-empty">Brak notatek</div>
    }
  }
}
